import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Iterator } from '../../../../../@core/components/ui/iterator/iterator.js';
import { FlexBox, Divider } from '@vp/swan';
import 'react';
import { OrderTrackingItem } from './OrderTrackingItem.js';

const OrderTrackingList=({items})=>{return jsx(FlexBox,{gap:"5",flexDirection:"column",children:jsx(Iterator,{of:items,render:(item,index)=>jsxs(Fragment,{children:[jsx(OrderTrackingItem,{item:item.itemData},`item-${item.id}-${index}`),items.length-1>index&&jsx(Divider,{my:"between-sections"})]})})})};

export { OrderTrackingList };
//# sourceMappingURL=OrderTrackingList.js.map
